import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ChatEntryView } from '@data/sdk/match';

export type WelcomeMessage = Partial<ChatEntryView>;

type WelcomeMessagesStore = {
  setWelcomeMessages: (messages: WelcomeMessage) => void;
  setWelcomeMessagesList: (messages: WelcomeMessage[]) => void;
  welcomeMessages: WelcomeMessage[];
};

export const useWelcomeMessagesStore = create<WelcomeMessagesStore>()(
  persist(
    (set) => ({
      welcomeMessages: [],
      setWelcomeMessages: (message) =>
        set((state) => ({ welcomeMessages: [message, ...state.welcomeMessages] })),
      setWelcomeMessagesList: (setWelcomeMessagesList) =>
        set(() => ({ welcomeMessages: setWelcomeMessagesList })),
    }),

    {
      name: 'welcome-messages',
    },
  ),
);

export const clearWelcomeMessagesStore = () => useWelcomeMessagesStore.persist.clearStorage();
